import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  selectGuaranteesAdministrationSupervisorInfoStatus,
  selectHasGuaranteesAdministrationAccess,
  selectShouldFetchGuaranteesAdministrationSupervisorInfo,
} from '~/store/guarantees/selectors.ts';
import { GuaranteesFetchStatus } from '~/store/guarantees/types.ts';
import { fetchGuaranteesAdministrationSupervisorInfo } from '~/store/guarantees/thunks/applicationThunks.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';
import type { RootState } from '~/store/store.ts';
import type { TSupervisorAdministrationPageKey } from './types.ts';

export const useSupervisorAdministrationAccess = (pageKey: TSupervisorAdministrationPageKey) => {
  const dispatch = useAppDispatch();
  const token = useSelector((state: RootState) => state.users.token);
  const hasAdministrationAccess = useSelector((state: RootState) =>
    selectHasGuaranteesAdministrationAccess(state, pageKey)
  );
  const supervisorInfoStatus = useSelector((state: RootState) =>
    selectGuaranteesAdministrationSupervisorInfoStatus(state, pageKey)
  );
  const shouldFetchSupervisorInfo = useSelector((state: RootState) =>
    selectShouldFetchGuaranteesAdministrationSupervisorInfo(state, pageKey)
  );

  useEffect(() => {
    if (!token || !shouldFetchSupervisorInfo) {
      return;
    }

    void dispatch(fetchGuaranteesAdministrationSupervisorInfo({ pageKey }));
  }, [dispatch, pageKey, shouldFetchSupervisorInfo, token]);

  return {
    hasSupervisorAdministrationAccess: hasAdministrationAccess,
    isSupervisorAdministrationAccessLoading:
      supervisorInfoStatus === GuaranteesFetchStatus.Idle ||
      supervisorInfoStatus === GuaranteesFetchStatus.Loading,
  };
};

